var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"upgrade-banner",on:{"click":_vm.handleOnBannerClick}},[_c('UpgradeIcon'),_c('span',{staticClass:"colorful-text"},[_vm._v("Upgrade to unlock")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }